import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'router';

/**
 * useGoBack returns a function that navigates back in app history.
 * If there is no previous app page (e.g. the user navigated directly via URL),
 * it navigates to the dashboard with a backward animation instead.
 */
export const useGoBack = () => {
  const navigate = useNavigate();

  return useCallback(() => {
    const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    if (idx > 0) {
      navigate(-1);
    } else {
      navigate(ROUTES.HOME, { replace: true, state: { back: true } });
    }
  }, [navigate]);
};
